export enum Environment {
    Local = "local",
    Test = "test",
    Acpt = "acpt",
    Prod = "prod"
}
